import { useAppTheme } from "@hooks/useAppTheme";
import { Avatar } from "react-native-paper";

import { getPersonaInitials } from "../data/scenario-registry";
import { useActiveScenario } from "../hooks/useActiveScenario";

export const PersonaAvatar = ({ size = 34 }: { size?: number }) => {
	const theme = useAppTheme();
	const { scenario, registry } = useActiveScenario();

	if (registry.avatarImage) {
		return (
			<Avatar.Image
				size={size}
				source={registry.avatarImage}
				style={{ backgroundColor: theme.colors.primary }}
			/>
		);
	}

	return (
		<Avatar.Text
			size={size}
			label={getPersonaInitials(scenario.persona.name)}
			style={{ backgroundColor: theme.colors.primary }}
			color={theme.colors.onPrimary}
		/>
	);
};
